import React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { ScrollingProvider } from 'react-scroll-section';
import config from 'react-reveal/globals';
import preset from '@rebass/preset';
import colors from '../../colors';
import Helmet from './Helmet';
import "../../static/fonts/fonts.css";

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before { 
    box-sizing: inherit;
    }

    body {
    box-sizing: border-box; 
    margin: 0;
    font-family: 'DM Mono', monospace;
    overflow-x: hidden;
    width: 100vw;
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
  }

  html {
    background: ${(props) => props.theme.colors.background};
  }
`;

config({ ssrFadeout: true });

const theme = {
  ...preset,
  colors,
  fonts: {
    body: "'DM Mono', monospace",
    heading: 'inherit',
    monospace: 'monospace',
  },
};

const Layout = ({ children }) => (
  <main>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ScrollingProvider>
        <Helmet />
        {children}
      </ScrollingProvider>
    </ThemeProvider>
  </main>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
